module.exports = __webpack_public_path__ + "img/header-weddingRingsBlack@2x.f2aec2b.jpg";